import { render, staticRenderFns } from "./SuppliersBookingSettingsDate.vue?vue&type=template&id=48b6842d&"
import script from "./SuppliersBookingSettingsDate.vue?vue&type=script&lang=js&"
export * from "./SuppliersBookingSettingsDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports